import React, { Component } from 'react';

import styles from './styles.less';

type Props = {
	children: React.ReactNode;
	isSelected: boolean;
	styles: { default: string; selected: string };
	'data-testid'?: string;
	name: string; // NOTE: must be required due to 'TabBar' context!
	onClick?(): void;
};

export default class Tab extends Component<Props> {
	static defaultProps = {
		isSelected: false,
		styles,
		onClick: null,
	};

	render() {
		const { children, isSelected, styles, onClick } = this.props;

		return (
			<li
				className={isSelected ? styles.selected : styles.default}
				data-testid={this.props['data-testid']}
				role='menuitem'
				onClick={onClick}
			>
				{children}
			</li>
		);
	}
}
